export default class {

  /**
   *
   * @param message
   * @param err
   */
  onError(message, err) {
    console.error(message, err);
  }

  /**
   *
   */
  getToken() {
    if (window.usingCordova) {
      window.FirebasePlugin.getToken(
        null,
        (error) => {
          this.onError("Failed to get FCM token", error);
        });
    }
  }
}
1
